export default class SettingsExpertisesController {
  constructor() {
    'ngInject';
  }

  $onInit() {
    this.certificationNames = this.settings.profile.educational_achievements.map(c => c.name);
  }

  onCertificationCreate(tag) {
    this.settings.profile.educational_achievements.push({name: tag});
  }

  onCertificationDelete(tag) {
    const deletingCertification = this.settings.profile.educational_achievements.find((certification) => {
      return certification.name === tag;
    });
    const index = this.settings.profile.educational_achievements.indexOf(deletingCertification);

    if (index > -1) {
      this.settings.profile.educational_achievements[index]['_destroy'] = 1;
    }
  }

  handleProfileSave() {
    this.updating = true;
    this.settings.profile.educational_achievements_attributes = this.settings.profile.educational_achievements;

    this.settings.profile.$update()
      .then(() => {
        this.updating = false;
      })
      .catch((response) => {
        this.updating = false;
        this.errors = response.data.errors;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/screens/settings-educational-achievements/settings-educational-achievements.controller.js